import OpportunityPage from './OpportunityPage';
export default OpportunityPage;
